// extracted by mini-css-extract-plugin
export default {"bubbleCaseTable":"BubbleCaseTable__bubbleCaseTable___nCzYT","header":"BubbleCaseTable__header___STpLr","addBtn":"BubbleCaseTable__addBtn___Sh0t5"};